import initialState from '../store/initialState';

const chapters = (state = initialState.chapters, action) => {
    switch (action.type) {

        default:
            return state
    }
}

export default chapters;



// WEBPACK FOOTER //
// ./src/reducers/chaptersReducer.js